import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'

import Home from 'containers/Home'
import Recipe from 'containers/Recipe'

class App extends Component {
  render () {
    return (
      <Router>
        <div className='Site-main'>
          <header className='Site-header'>
            <h1><Link to='/'>Stupid matkasse</Link></h1>
          </header>
          <div className='Site-content'>
            <Route path='/' exact component={Home} />
            <Route path='/:seed' component={Recipe} />
          </div>
        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/index.js